export function initOembedContainers() {
   onDomReady(() => {
      // Initialize all oembeds
      $$('.oembedContainer').each(oembed => {
         let iframe = oembed.getChildren('iframe');
         if (iframe.length > 0) {
            iframe.set('width', oembed.getStyle('width'));
            iframe.set('height', oembed.getStyle('height'));
         } else {
            return;
         }
      });
   });
}
